import { render, staticRenderFns } from "./shippingOperation.vue?vue&type=template&id=10fefa1a"
import script from "./shippingOperation.vue?vue&type=script&lang=js"
export * from "./shippingOperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports